<template>
  <div id="member-subscription-list">
    <v-container class="py-0">
      <v-speed-dial
        v-if="FloatingButtonFlag"
        v-model="fab"
        :top="top"
        :bottom="bottom"
        :right="right"
        :left="left"
        :direction="direction"
        :open-on-hover="hover"
        :transition="transition"
        :fixed="true"
      >
        <template v-slot:activator>
          <v-btn
            v-model="fab"
            color="#3A67B1"
            dark
            fab
            class="fab-primary"
            elevation="6"
          >
            <v-icon v-if="fab"> mdi-close </v-icon>
            <v-icon v-else> mdi-account-circle </v-icon>
          </v-btn>
        </template>
        <!-- <v-btn fab dark small color="green">
          <v-icon>mdi-pencil</v-icon>
        </v-btn> -->
        <v-btn
          fab
          dark
          small
          color="#56BDA3"
          @click.prevent="addRecordPrompt = true"
          class="fab-secondary"
        >
          <v-icon>mdi-plus</v-icon>
        </v-btn>
        <!-- <v-btn fab dark small color="red">
          <v-icon>mdi-delete</v-icon>
        </v-btn> -->
      </v-speed-dial>
    </v-container>
    <v-dialog v-model="addRecordPrompt" persistent max-width="600px">
      <staff-create
        pageDescription="Create Staff"
        :addRecordPrompt="addRecordPrompt"
        @hideAddRecordPrompt="hideAddRecordPrompt"
        v-if="addRecordPrompt"
      ></staff-create>
    </v-dialog>
    <v-card class="modern-card-wrapper elevation-2">
      <v-card-title class="modern-card-title pa-0">
        <div class="header-content">
          <div class="header-left">
            <v-icon class="flying-icon" size="36px">mdi-briefcase-check</v-icon>
            <div>
              <h2 class="page-title">Subscription Payments</h2>
              <p class="page-subtitle">Manage and track member subscriptions</p>
            </div>
          </div>
        </div>
      </v-card-title>

      <v-card-subtitle class="modern-subtitle">
        <div class="subtitle-content">
          <p class="subtitle-text">
            Kindly select the members below subscriptions.
          </p>
          <v-icon size="24px" color="#56BDA3" class="icon-accent">
            mdi-account-multiple-plus
          </v-icon>
          <span class="icon-label">Click to add members</span>
        </div>
      </v-card-subtitle>

      <v-card-text>
        <v-container>
          <v-row wrap>
            <v-col cols="12" md="12" align="center">
              <v-btn
                elevation="4"
                small
                color="#0097D7"
                class="font-size-h6 white--text refresh-btn"
                @click.prevent="refreshPageData"
              >
                <v-icon left size="20px">mdi-refresh</v-icon>
                Refresh
              </v-btn>
            </v-col>
          </v-row>
        </v-container>
        <br />
        <div class="d-flex justify-content-center mb-3" v-if="LoadingFlag">
          <b-spinner
            variant="primary"
            type="grow"
            label="Loading..."
          ></b-spinner>
        </div>
        <v-container class="py-0" v-if="StartupLoadingFlag">
          <v-skeleton-loader
            v-bind="attrs"
            type="table-tbody"
          ></v-skeleton-loader>
        </v-container>
        <v-container
          class="py-0"
          v-if="!StartupLoadingFlag && ResultFlag && rows.length == 0"
        >
          <v-row wrap>
            <v-col align="center" cols="12" md="12">
              <div class="no-records-container">
                <v-icon size="48px" color="#3A67B1">mdi-inbox-outline</v-icon>
                <h4 class="no-records-text">No records found.</h4>
              </div>
            </v-col>
          </v-row>
        </v-container>
        <v-container class="py-0" v-if="rows.length > 0">
          <v-row wrap>
            <v-col align="center" cols="12" md="12">
              <h3></h3>
            </v-col>
          </v-row>
          <v-row wrap>
            <v-col align="center" cols="12" md="12">
              <!-- <v-text-field
                v-model="search"
                append-icon="mdi-magnify"
                label="Search records here"
                single-line
                hide-details
              ></v-text-field> -->
              <br />
              <v-data-table
                class="modern-data-table elevation-3"
                v-model="selected"
                :headers="tableColumns1"
                :items="rows"
                :items-per-page="50"
                :search="search"
                item-key="MemberId"
                :single-select="false"
                :show-select="false"
                :footer-props="{
                  'items-per-page-options': [10, 20, 30, 40, 50],
                }"
              >
                <template v-slot:item.ActiveStatusTxt="{ item }">
                  <v-chip
                    :color="getActiveStatusColor(item.ActiveStatusTxt)"
                    draggable
                    dark
                    >{{ item.ActiveStatusTxt }}</v-chip
                  >
                </template>
                <template v-slot:item.ProfilePic="{ item }">
                  <img width="100" height="100" :src="item.ProfilePic" />
                </template>
                <template v-slot:item.actions="{ item }">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon
                        class="mr-2"
                        icon
                        size="25px"
                        color="blue"
                        @click="previewData(item, e)"
                        v-bind="attrs"
                        v-on="on"
                        v-if="item.ActiveStatus == 2"
                      >
                        mdi-clipboard-text-search
                      </v-icon>
                    </template>
                    <span> Preview </span>
                  </v-tooltip>

                  <!-- Add Members Button - Visible when conditions are met -->
                  <v-tooltip
                    bottom
                    v-if="item.AddMemberFlag && item.AdavancePaidFlag"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon
                        icon
                        size="25px"
                        color="#56BDA3"
                        @click="previewData(item, 1, e)"
                        v-bind="attrs"
                        v-on="on"
                      >
                        mdi-account-multiple-plus
                      </v-icon>
                    </template>
                    <span> Add members </span>
                  </v-tooltip>

                  <!-- Alert Text when button is NOT visible - Show disabled reason directly -->
                  <div
                    v-if="!item.AddMemberFlag || !item.AdavancePaidFlag"
                    class="alert-message-box"
                  >
                    <v-icon
                      size="18px"
                      color="#FFA726"
                      class="alert-icon-inline"
                    >
                      mdi-alert-circle
                    </v-icon>
                    <span class="alert-text-inline">
                      <template v-if="!item.AdavancePaidFlag">
                        <strong>Pending Balance ! </strong>
                        Members can be added only after the balance payment is
                        completed.
                      </template>
                      <template v-else>
                        Check remaining count or subscription type
                      </template>
                    </span>
                  </div>

                  <!-- Member Transfer Button -->
                  <v-tooltip bottom v-if="item.MemberTransferFlag">
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon
                        icon
                        size="25px"
                        color="primary"
                        @click="previewData(item, 2, e)"
                        v-bind="attrs"
                        v-on="on"
                      >
                        mdi-repeat
                      </v-icon>
                    </template>
                    <span> Transfer members </span>
                  </v-tooltip>
                </template>
              </v-data-table>
            </v-col>
          </v-row>
        </v-container>
        <br /><br />
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import common from "@/view/Common.vue";
import companyConfig from "@/company_config.json";
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import {
  ADD_BODY_CLASSNAME,
  REMOVE_BODY_CLASSNAME,
} from "@/core/services/store/htmlclass.module.js";
import StaffCreate from "@/view/pages/erp/staff/StaffCreate.vue";

export default {
  mixins: [common],
  components: {
    StaffCreate,
  },
  data() {
    return {
      valid1: true,
      valid2: true,
      LoadingFlag: false,
      StartupLoadingFlag: false,
      FloatingButtonFlag: false,
      SearchFlag: false,
      SubmitFlag: false,
      ResultFlag: false,

      rows: [],
      tableColumns1: [],
      selected: [],
      search: "",
      CurrentYearId: 0,

      direction: "top",
      fab: true,
      fling: false,
      hover: true,
      tabs: null,
      top: false,
      right: true,
      bottom: true,
      left: false,
      transition: "slide-y-reverse-transition",

      addRecordPrompt: false,
      editRecordPrompt: false,
      previewRecordPrompt: false,

      zone: {},
      lom: {},

      name: "",
      nameRules: [
        (v) => !!v || "Name is required",
        (v) => (v && v.length <= 10) || "Name must be less than 10 characters",
      ],
      email: "",
      emailRules: [
        (v) => !!v || "E-mail is required",
        (v) => /.+@.+\..+/.test(v) || "E-mail must be valid",
      ],
      select: "Item 1",
      items: ["Item 1", "Item 2", "Item 3", "Item 4"],
      checkbox: false,

      FromZoneCodeRules: [(v) => !!v || "Zone is required"],
      FromZoneCode: "",
      FromZoneCodeOptions: [],
      FromZoneCodeOptionsLoading: false,

      FromLomCodeRules: [(v) => !!v || "LOM is required"],
      FromLomCode: "",
      FromLomCodeOptions: [],
      FromLomCodeOptionsLoading: false,

      ToZoneCodeRules: [(v) => !!v || "Zone is required"],
      ToZoneCode: "",
      ToZoneCodeOptions: [],
      ToZoneCodeOptionsLoading: false,

      ToLomCodeRules: [(v) => !!v || "LOM is required"],
      ToLomCode: "",
      ToLomCodeOptions: [],
      ToLomCodeOptionsLoading: false,

      SearchId: "",
      SearchIdRules: [(v) => !!v || "Search Type is required"],
      SearchIdOptions: [
        { value: "", text: "--Select Type--" },
        { value: 1, text: "By LOM" },
        { value: 2, text: "By Membership Id" },
      ],

      MembershipId: "",
      MembershipIdRules: [(v) => !!v || "Membership Id is required"],

      YearHalfId: "",
      YearHalfIdRules: [(v) => !!v || "Year Half is required"],
      YearHalfIdOptions: [
        { value: "", text: "--Select Half--" },
        { value: "First", text: "First Half" },
        { value: "Second", text: "Second Half" },
      ],

      YearIdRules: [(v) => !!v || "Year is required"],
      YearId: "",
      YearIdOptions: [],
      YearIdOptionsLoading: false,

      ApprovalDescription: "",
      ApprovalDescriptionRules: [],
    };
  },
  mounted() {
    /*
    this.$store.dispatch(SET_BREADCRUMB, [
      { title: "Vuetify", route: "alerts" },
      { title: "Form Inputs & Control", route: "autocompletes" },
      { title: "Fileinptus" },
    ]);
    */
  },
  watch: {
    SearchId: function () {
      console.log("watch SearchId");
      this.rows = [];
    },
  },
  methods: {
    // code 1
    validate() {
      if (this.$refs.form2.validate()) {
        this.snackbar = true;
      }
    },
    hideAddRecordPrompt() {
      console.log("hideAddRecordPrompt called");
      this.addRecordPrompt = false;
      this.getTableRecords();
    },
    resetForm() {
      this.search = "";
      this.rows = [];
      this.selected = [];
      this.$refs.form3.reset();
    },
    resetValidation() {
      this.$refs.form2.resetValidation();
    },
    previewData(tr, type) {
      console.log("previewData called");
      console.log("type=" + type);
      var n1 = Object.keys(tr).length;
      console.log("n1=" + n1 + ", tr=" + JSON.stringify(tr));
      if (n1 > 0) {
        var url =
          type == 1
            ? "/members/subscription/assign"
            : "/members/transfer/assign";
        console.log("url=" + url);
        var id = tr.LomPaymentId;
        console.log("id=" + id);
        var params = {
          id: id,
        };
        this.pageRedirect(params, url);
      } else {
        var message = "Kindly select one lom to preview";
        this.toast("error", message);
      }
    },
    refreshPageData() {
      console.log("refreshPageData called");
      this.getTableRecords();
    },
    getTableRecords() {
      console.log("getTableRecords called");

      var LomCode = this.$session.get("LomId");
      LomCode = LomCode == (null || undefined) ? 0 : LomCode;
      console.log("LomCode=" + LomCode);

      if (LomCode != null) {
        var server_url = companyConfig.apiURL;
        var token = this.$session.get("token");
        token = token == (null || undefined) ? 0 : token;
        var add_url = server_url + "api/lom-payment/lists";
        var upload = {
          UserInterface: 1,
          LomCode: LomCode,
        };
        console.log("upload=" + JSON.stringify(upload));
        console.log(
          "server_url=" +
            server_url +
            ", token=" +
            token +
            ", add_url=" +
            add_url
        );

        const thisIns = this;
        var output = "";
        var records = "";
        var successTxt = "";
        var errorTxt = "";
        var flag = 0;

        this.rows = [];
        this.ResultFlag = false;
        this.LoadingFlag = true;
        this.StartupLoadingFlag = true;

        this.$http({
          url: add_url,
          method: "POST",
          data: upload,
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
          },
          onUploadProgress: function (progressEvent) {
            this.uploadPercentage = parseInt(
              Math.round((progressEvent.loaded / progressEvent.total) * 100)
            );
          }.bind(this),
        })
          .then(function (response) {
            console.log("response=" + JSON.stringify(response));

            thisIns.ResultFlag = true;
            thisIns.LoadingFlag = false;
            thisIns.StartupLoadingFlag = false;

            output = response.data.output;
            flag = response.data.flag;
            output = response.data.output;
            records = response.data.records;
            console.log("output=" + output + ", flag=" + flag);
            successTxt = response.data.success;
            errorTxt = response.data.error;
            console.log("successTxt=" + successTxt + ", errorTxt=" + errorTxt);

            if (flag == 1) {
              thisIns.rows = records;
              thisIns.toast("success", output);
            } else {
              thisIns.toast("error", output);
            }
          })
          .catch(function (error) {
            console.log("error=" + error);
            thisIns.toast("error", error);
            thisIns.ResultFlag = true;
            thisIns.LoadingFlag = false;
            thisIns.StartupLoadingFlag = false;
          });
      } else {
        var message = "LOM should not be empty.";
        console.log("error=" + message);
      }
    },
    getZoneCodeOptions(source, destination) {
      console.log("getZoneCodeOptions called");
      // this.$store.dispatch(ADD_BODY_CLASSNAME, "page-loading");
      var CurrentYearId = this.CurrentYearId;
      console.log(
        "source=" +
          source +
          ", destination=" +
          destination +
          ", CurrentYearId=" +
          CurrentYearId
      );
      if (source != "" && destination != "") {
        this.LoadingFlag = true;
        var selectbox1_source = source;
        var selectbox1_destination = destination;
        var selectbox1_url = "api/year-wise-lom/zone-options";
        var selectbox1_conditions_array = {
          UserInterface: 2,
          YearCode: CurrentYearId,
        };
        this.getSelectBoxOptions(
          selectbox1_source,
          selectbox1_destination,
          selectbox1_conditions_array,
          selectbox1_url
        );
      }
    },
    getLomCodeOptions(source, destination, ZoneCode) {
      console.log("getLomCodeOptions called");
      console.log(
        "source=" +
          source +
          ", destination=" +
          destination +
          ", ZoneCode=" +
          ZoneCode
      );
      var CurrentYearId = this.CurrentYearId;
      if (ZoneCode != "" && CurrentYearId != "") {
        var selectbox1_source = source;
        var selectbox1_destination = destination;
        var selectbox1_url = "api/year-wise-lom/lom-options";
        var selectbox1_conditions_array = {
          UserInterface: 1,
          YearCode: CurrentYearId,
          ZoneCode: ZoneCode,
        };
        this.getSelectBoxOptions(
          selectbox1_source,
          selectbox1_destination,
          selectbox1_conditions_array,
          selectbox1_url
        );
      } else {
        var message = "Zone should not be empty";
        this.toast("error", message);
      }
    },
    getYearCodeOptions(source, destination) {
      console.log("getYearCodeOptions called");
      // this.$store.dispatch(ADD_BODY_CLASSNAME, "page-loading");
      // var CurrentYearId = this.CurrentYearId;
      var CurrentYearId = 1;
      console.log(
        "source=" +
          source +
          ", destination=" +
          destination +
          ", CurrentYearId=" +
          CurrentYearId
      );
      if (source != "" && destination != "") {
        this.LoadingFlag = true;
        var selectbox1_source = source;
        var selectbox1_destination = destination;
        var selectbox1_url = "api/jci-year/options";
        var selectbox1_conditions_array = {
          UserInterface: 1,
        };
        this.getSelectBoxOptions(
          selectbox1_source,
          selectbox1_destination,
          selectbox1_conditions_array,
          selectbox1_url
        );
      }
    },
    searchForm() {
      console.log("searchForm is called");

      var validate1 = this.$refs.form2.validate();
      var SearchId = this.SearchId;
      var UserInterface = SearchId == 1 ? 1 : 3;
      console.log(
        "validate1=" +
          validate1 +
          ", SearchId=" +
          SearchId +
          ", UserInterface=" +
          UserInterface
      );

      if (validate1) {
        this.SearchFlag = true;
        this.rows = [];
        this.zone = {};
        this.lom = {};

        var server_url = companyConfig.apiURL;
        var token = this.$session.get("token");
        token = token == (null || undefined) ? 0 : token;
        var add_url = server_url + "api/members";
        var upload = {
          UserInterface: UserInterface,
          additional: {
            MembershipId: this.MembershipId,
            LomCode: this.FromZoneCode,
            LomCode: this.FromLomCode,
          },
        };
        console.log("upload=" + JSON.stringify(upload));
        console.log(
          "server_url=" +
            server_url +
            ", token=" +
            token +
            ", add_url=" +
            add_url
        );

        const thisIns = this;
        var output = "";
        var records = "";
        var successTxt = "";
        var errorTxt = "";
        var flag = 0;

        this.$http({
          url: add_url,
          method: "POST",
          data: upload,
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
          },
          onUploadProgress: function (progressEvent) {
            this.uploadPercentage = parseInt(
              Math.round((progressEvent.loaded / progressEvent.total) * 100)
            );
          }.bind(this),
        })
          .then(function (response) {
            console.log("response=" + JSON.stringify(response));

            // thisIns.pageLoadingOff()
            thisIns.SearchFlag = false;

            output = response.data.output;
            flag = response.data.flag;
            output = response.data.output;
            records = response.data.records;
            console.log("output=" + output + ", flag=" + flag);
            successTxt = response.data.success;
            errorTxt = response.data.error;
            console.log("successTxt=" + successTxt + ", errorTxt=" + errorTxt);

            if (flag == 1) {
              thisIns.toast("success", output);
              thisIns.rows = records;
              thisIns.zone = response.data.zone;
              thisIns.lom = response.data.lom;
            } else {
              thisIns.toast("error", output);
            }
          })
          .catch(function (error) {
            console.log("error=" + error);
            thisIns.SearchFlag = false;
          });
      } else {
        var message = "Kindly fill the required fields";
        this.toast("error", message);
      }
    },
    submitForm() {
      console.log("submitForm is called");

      var validate1 = this.$refs.form2.validate();
      var validate2 = this.$refs.form3.validate();
      console.log("validate1=" + validate1 + "validate2=" + validate2);

      var members = this.selected;
      var n1 = members.length;
      console.log("n1=" + n1 + ", members=" + JSON.stringify(members));

      // this.rows = [];

      if (validate1 && validate2 && n1 > 0) {
        this.SubmitFlag = true;

        var server_url = companyConfig.apiURL;
        var token = this.$session.get("token");
        token = token == (null || undefined) ? 0 : token;
        var add_url = server_url + "api/members/transfer";
        var upload = {
          UserInterface: this.SearchId,
          FromZoneCode: this.FromZoneCode,
          FromLomCode: this.FromLomCode,
          MembershipId: this.MembershipId,
          ToZoneCode: this.ToZoneCode,
          ToLomCode: this.ToLomCode,
          YearId: this.YearId,
          YearHalf: this.YearHalfId,
          ApprovalDescription: this.ApprovalDescription,
          Members: members,
        };
        console.log("upload=" + JSON.stringify(upload));
        console.log(
          "server_url=" +
            server_url +
            ", token=" +
            token +
            ", add_url=" +
            add_url
        );

        const thisIns = this;
        var output = "";
        var records = "";
        var successTxt = "";
        var errorTxt = "";
        var flag = 0;

        this.$http({
          url: add_url,
          method: "POST",
          data: upload,
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
          },
          onUploadProgress: function (progressEvent) {
            this.uploadPercentage = parseInt(
              Math.round((progressEvent.loaded / progressEvent.total) * 100)
            );
          }.bind(this),
        })
          .then(function (response) {
            console.log("response=" + JSON.stringify(response));

            thisIns.SubmitFlag = false;

            output = response.data.output;
            flag = response.data.flag;
            output = response.data.output;
            records = response.data.records;
            console.log("output=" + output + ", flag=" + flag);
            successTxt = response.data.success;
            errorTxt = response.data.error;
            console.log("successTxt=" + successTxt + ", errorTxt=" + errorTxt);

            if (flag == 1) {
              thisIns.toast("success", output);
              thisIns.resetForm();
            } else {
              thisIns.toast("error", output);
            }
          })
          .catch(function (error) {
            console.log("error=" + error);
            thisIns.SubmitFlag = false;
          });
      } else {
        var message = "";
        if (!validate1 || !validate2) {
          message += "Kindly fill the required fields";
        }
        if (n1 == 0) {
          message += "Atleast one member is required to transfer";
        }
        this.toast("error", message);
      }
    },
  },
  beforeMount() {
    var CurrentYearId = this.$session.get("CurrentYearId");
    CurrentYearId = 1;
    CurrentYearId = CurrentYearId == (null || undefined) ? 0 : CurrentYearId;
    this.CurrentYearId = CurrentYearId;
    this.refreshPageData();
    this.tableColumns1.push(
      { text: "Paid Date", value: "PaidDateTxt" },
      { text: "Year", value: "YearName" },
      {
        text: "Subscription Description",
        value: "ContributionTypeDescription",
      },
      { text: "Paid Count", value: "PaidCount" },
      { text: "Remaining Count", value: "RemainingCount" },
      { text: "Add members", value: "actions" }
    );
  },
};
</script>
<style lang="scss">
#member-subscription-list {
  font-family: "Poppins", sans-serif;
  background-color: #f4f7fa;

  // --- Animations ---
  @keyframes slideUp {
    from {
      opacity: 0;
      transform: translateY(40px);
    }

    to {
      opacity: 1;
      transform: translateY(0);
    }
  }

  @keyframes pulse-glow {
    0% {
      box-shadow: 0 0 0 0 rgba(58, 103, 177, 0.4);
    }

    70% {
      box-shadow: 0 0 0 15px rgba(58, 103, 177, 0);
    }

    100% {
      box-shadow: 0 0 0 0 rgba(58, 103, 177, 0);
    }
  }

  @keyframes fly {
    0% {
      transform: translateY(0) translateX(0);
    }

    50% {
      transform: translateY(-5px) translateX(5px);
    }

    100% {
      transform: translateY(0) translateX(0);
    }
  }

  @keyframes shimmer {
    0% {
      background-position: -200% center;
    }

    100% {
      background-position: 200% center;
    }
  }

  // --- Header Styles ---
  .modern-card-wrapper {
    border-radius: 20px;
    margin-bottom: 30px;
    overflow: hidden;
    background: white;
    transition: all 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275);
    border: 1px solid rgba(255, 255, 255, 0.8);
    animation: slideUp 0.8s cubic-bezier(0.2, 0.8, 0.2, 1) forwards;

    &:hover {
      transform: translateY(-5px);
      box-shadow: 0 20px 40px rgba(0, 0, 0, 0.08) !important;
    }
  }

  .modern-card-title {
    padding: 32px !important;
    display: flex;
    align-items: center;
    justify-content: space-between;
    background: linear-gradient(135deg, #3a67b1 0%, #2a5299 100%);
    position: relative;
    overflow: hidden;

    .header-content {
      display: flex;
      align-items: center;
      width: 100%;
      z-index: 2;
      position: relative;
    }

    .header-left {
      display: flex;
      align-items: center;
      gap: 16px;
      flex: 1;
    }
  }

  .flying-icon {
    animation: fly 3s ease-in-out infinite;
    filter: drop-shadow(0 4px 8px rgba(0, 0, 0, 0.3));
    color: #ffffff;
  }

  .page-title {
    font-size: 28px;
    font-weight: 800;
    color: #ffffff;
    margin: 0;
    line-height: 1.2;
    letter-spacing: -0.5px;
    text-shadow: 0 4px 10px rgba(255, 255, 255, 0.3);
  }

  .page-subtitle {
    font-size: 15px;
    color: rgba(255, 255, 255, 0.85);
    margin-top: 4px;
    margin-bottom: 0;
    font-weight: 500;
    letter-spacing: 0.5px;
  }

  // --- Subtitle Styles ---
  .modern-subtitle {
    padding: 24px 32px !important;
    background: linear-gradient(to bottom right, #ffffff, #f8faff);
    border-bottom: 1px solid rgba(58, 103, 177, 0.1);

    .subtitle-content {
      display: flex;
      align-items: center;
      gap: 12px;
      flex-wrap: wrap;
    }

    .subtitle-text {
      font-size: 16px;
      color: #0a0f29;
      font-weight: 600;
      margin: 0;
      letter-spacing: 0.3px;
    }

    .icon-accent {
      color: #56bda3 !important;
    }

    .icon-label {
      font-size: 14px;
      color: #414042;
      font-weight: 600;
    }
  }

  // --- Floating Action Button Styles ---
  .fab-primary {
    animation: pulse-glow 3s infinite;
    transition: all 0.3s ease;

    &:hover {
      transform: scale(1.1);
      box-shadow: 0 10px 30px rgba(58, 103, 177, 0.4) !important;
    }
  }

  .fab-secondary {
    transition: all 0.3s ease;

    &:hover {
      transform: scale(1.05);
      box-shadow: 0 8px 20px rgba(86, 189, 163, 0.4) !important;
    }
  }

  .v-btn--floating {
    position: relative;
  }

  .v-speed-dial--bottom {
    bottom: 12%;
  }

  .v-speed-dial--right {
    right: 5%;
  }

  // --- Refresh Button Styles ---
  .refresh-btn {
    font-weight: 700;
    letter-spacing: 0.5px;
    border-radius: 10px;
    transition: all 0.3s ease;
    background: linear-gradient(135deg, #0097d7 0%, #0077b6 100%) !important;
    box-shadow: 0 6px 20px rgba(0, 151, 215, 0.3);

    &:hover {
      transform: translateY(-2px);
      box-shadow: 0 10px 28px rgba(0, 151, 215, 0.4) !important;
    }
  }

  // --- No Records Container ---
  .no-records-container {
    padding: 60px 40px;
    text-align: center;
    background: linear-gradient(to bottom right, #ffffff, #f8faff);
    border-radius: 16px;
    border: 2px dashed rgba(58, 103, 177, 0.2);
    transition: all 0.4s ease;

    &:hover {
      border-color: rgba(58, 103, 177, 0.4);
      background: linear-gradient(to bottom right, #f8faff, #f0f4ff);
    }
  }

  .no-records-text {
    font-size: 18px;
    color: #0a0f29;
    font-weight: 700;
    margin-top: 16px;
    margin-bottom: 0;
    letter-spacing: 0.3px;
  }

  // --- Table Styles ---
  .modern-data-table {
    border-radius: 14px;
    overflow: hidden;
    box-shadow: 0 8px 20px rgba(58, 103, 177, 0.08) !important;
    border: 1px solid rgba(58, 103, 177, 0.15) !important;

    thead {
      background: linear-gradient(135deg, #3a67b1 0%, #2a5299 100%) !important;

      th {
        font-size: 15px !important;
        font-weight: 800 !important;
        color: #ffffff !important;
        background: linear-gradient(
          135deg,
          #3a67b1 0%,
          #2a5299 100%
        ) !important;
        letter-spacing: 0.5px;
        border: none !important;
        padding: 16px 12px !important;
        text-transform: uppercase;
        box-shadow: 0 4px 12px rgba(58, 103, 177, 0.2) !important;
      }
    }

    tbody {
      tr {
        transition: all 0.3s ease;
        border-bottom: 1px solid rgba(58, 103, 177, 0.1) !important;

        &:hover {
          background: rgba(58, 103, 177, 0.04) !important;
          transform: scale(1.01);
          box-shadow: inset 0 0 10px rgba(58, 103, 177, 0.05);
        }

        &:last-child {
          border-bottom: none !important;
        }
      }

      td {
        font-size: 14px !important;
        color: #414042 !important;
        font-weight: 500;
        padding: 14px 12px !important;
        border: none !important;
        letter-spacing: 0.2px;
      }
    }
  }

  // --- Custom Field Styling ---
  .v-data-table > .v-data-table__wrapper > table > thead > tr > th {
    font-size: 15px;
  }

  .v-data-table > .v-data-table__wrapper > table > tbody > tr > td {
    font-size: 14px;
  }

  // --- Chip Styling ---
  .v-chip {
    font-weight: 700;
    letter-spacing: 0.5px;
    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1) !important;
  }

  // --- Icon Hover Effects ---
  .v-icon {
    transition: all 0.3s ease;

    &:hover {
      transform: scale(1.15) rotate(10deg);
    }
  }

  // --- Alert Button Disabled Styles ---
  .alert-message-box {
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 8px 12px;
    background: linear-gradient(
      135deg,
      rgba(255, 167, 38, 0.15),
      rgba(255, 167, 38, 0.08)
    );
    border-left: 4px solid #ffa726;
    border-radius: 6px;
    transition: all 0.3s ease;

    &:hover {
      background: linear-gradient(
        135deg,
        rgba(255, 167, 38, 0.25),
        rgba(255, 167, 38, 0.15)
      );
      box-shadow: 0 4px 12px rgba(255, 167, 38, 0.2);
      transform: translateX(2px);
    }
  }

  .alert-icon-inline {
    flex-shrink: 0;
    animation: alert-pulse-inline 2s infinite;
  }

  @keyframes alert-pulse-inline {
    0%,
    100% {
      opacity: 1;
    }

    50% {
      opacity: 0.7;
    }
  }

  .alert-text-inline {
    font-size: 12px;
    font-weight: 600;
    color: #0a0f29;
    line-height: 1.3;
    word-break: break-word;
  }

  .alert-button-disabled {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    cursor: help;
    padding: 6px;
    border-radius: 50%;
    background: linear-gradient(
      135deg,
      rgba(255, 167, 38, 0.1),
      rgba(255, 167, 38, 0.05)
    );
    border: 2px solid rgba(255, 167, 38, 0.3);
    transition: all 0.3s ease;

    &:hover {
      background: linear-gradient(
        135deg,
        rgba(255, 167, 38, 0.2),
        rgba(255, 167, 38, 0.1)
      );
      border-color: rgba(255, 167, 38, 0.6);
      transform: scale(1.1);
      box-shadow: 0 0 12px rgba(255, 167, 38, 0.3);
    }
  }

  .alert-icon {
    animation: alert-blink 2s infinite;
  }

  @keyframes alert-blink {
    0%,
    100% {
      opacity: 1;
    }

    50% {
      opacity: 0.6;
    }
  }

  .alert-tooltip-text {
    font-size: 13px;
    font-weight: 600;
    max-width: 280px;
    word-wrap: break-word;
    color: #0a0f29;
    line-height: 1.4;
  }

  // --- Container Styling ---
  v-container {
    padding: 24px;
  }
}
</style>